<template>
	<div id="main_container">
		<v-navigation-drawer 
			v-model="drawer"
			app
			:permanent="!$vuetify.breakpoint.xs"
			class="d-print-none navi-hover"
			:mini-variant="mini"
			:width="280"
			@click.native="onMenuClick()"
		>
			<v-list dense nav class="px-0">
				<div v-for="(menuline, index) in menulines" :key="menuline.title">
					<div v-if="$store.getters.has_privilege(menuline.privilege)">
						<v-divider v-if="menuline.divider"/>
						<v-tooltip v-if="mini" right>
							<template v-slot:activator="{ on, attrs }">
								<v-list-item
									v-if="menuline.details.length == 0"
									link
									v-bind="attrs"
									v-on="on"
									:color="menuline.color" 
									:to="menuline.to"
									:class="`menu-${index}`"
									class="pl-4"
									@click.stop
								>
									<v-list-item-icon>
										<component 
											:is="menuline.icon" 
											:color="menuline.color" 
											width="20" 
											height="20" 
										/>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>{{ menuline.title }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
							<span>{{ menuline.title }}</span>
						</v-tooltip>
						<template v-if="!mini">
							<v-list-item
								v-if="menuline.details.length == 0"
								link
								:color="menuline.color" 
								:to="menuline.to"
								:class="`menu-${index}`"
								class="pl-4"
								@click.stop
							>
								<v-list-item-icon>
									<component 
										:is="menuline.icon" 
										:color="menuline.color" 
										width="20" 
										height="20" 
									/>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>{{ menuline.title }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
						<v-tooltip v-if="mini" right>
							<template v-slot:activator="{ on, attrs }">
								<v-list-group
									v-if="menuline.details.length > 0"
									v-model="menuline.active"
									:color="menuline.color"
									:class="`menu-${index}`"
									v-bind="attrs"
									v-on="on"
									@click.stop="onMenulineClick(menuline)"
								> 
							
									<template v-slot:activator>
										<v-list-item-icon>
											<component 
												:is="menuline.icon" 
												:color="menuline.color" 
												width="20" 
												height="20" 
												class="ml-2"
											/>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>{{ menuline.title }}</v-list-item-title>
										</v-list-item-content>
									</template>
									<div 
										v-for="detail in menuline.details"
										:key="detail.title"
										@click.stop="onMenulineDetailClick(detail)"
										class="menu_group_item">
										<component 
											:is="detail.type"
											:detail="detail"
											:color="menuline.color"
											v-if="$store.getters.has_privilege(detail.privilege)"
										/>
									</div>
								</v-list-group>
							</template>
							<span>{{ menuline.title }}</span>
						</v-tooltip>
						<template v-if="!mini">
							<v-list-group
								v-if="menuline.details.length > 0"
								v-model="menuline.active"
								:color="menuline.color"
								:class="`menu-${index}`"
								@click.stop="onMenulineClick(menuline)"
							> 
								<template v-slot:activator>
									<v-list-item-icon>
										<component 
											:is="menuline.icon" 
											:color="menuline.color" 
											width="20" 
											height="20" 
											class="ml-2"
										/>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>{{ menuline.title }}</v-list-item-title>
									</v-list-item-content>
								</template>
								<div 
									v-for="detail in menuline.details"
									:key="detail.title"
									@click.stop="onMenulineDetailClick(detail)"
									class="menu_group_item">
									<component 
										:is="detail.type"
										:detail="detail"
										:color="menuline.color"
										v-if="$store.getters.has_privilege(detail.privilege)"
									/>
								</div>
							</v-list-group>
						</template>				
					</div>
				</div>
			</v-list>
			<template v-slot:append>
				<div>
					<v-btn v-if="mini" width="20" height="20" class="float-right my-2 mx-5" depressed fab color="rgba(25, 42, 62, 0.15)" @click.stop="onMenuClick()">
						<v-icon color="white">mdi-chevron-right</v-icon>
					</v-btn>
					<v-btn v-if="!mini" width="20" height="20" class="float-right my-2 mx-5" depressed fab color="rgba(25, 42, 62, 0.15)" @click.stop="onMenuClick()">
						<v-icon color="white">mdi-chevron-left</v-icon>
					</v-btn>
				</div>
			</template>
		</v-navigation-drawer>
		<v-toolbar 
			color="#192a3e"
			dense
			class="d-print-none header_navigation"
		>
			<v-app-bar-nav-icon color="#DADADA" @click.stop="onMenuClick()"></v-app-bar-nav-icon>
			<breadcrumbs/> 
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<div v-if="recording_task_id !== 0" class="toolbar-item" @click="onStopRecording()">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<div class="toolbar-item" v-bind="attrs" v-on="on">
								<span class="time-text">TIMING</span>
								<autotimer width="20" height="20" color="#81CC00"/>
							</div>
						</template>
						<div>
							<div>Task name is {{ task_title }} </div>
							<div>{{ job_code }}  Job name is {{ job_name }}</div>
						</div>
					</v-tooltip>
				</div>
				<v-divider vertical inset class="d-none d-sm-flex" color="white"></v-divider>
				<div class="user-avatar-tmp">
					<v-user-avatar
						size="24"
						class="text-caption text-decoration-none"
						:code="user_short"
						:image="user_image"
					/>
				</div>
				<!-- <v-btn 
					icon dark
					:ripple="{ center: true }"
				>
					<router-link to="/profile">
						<v-user-avatar
							size="24"
							float="right"
							class="text-caption text-decoration-none"
							:code="user_short"
							:image="user_image"
						/>
					</router-link>
				</v-btn> -->
				<v-divider vertical inset class="d-none d-sm-flex" color="white"></v-divider>
				<div class="toolbar-item" @click="onHelp()">
					<div class="toolbar_comment_text d-none d-sm-flex">HELP</div>
					<v-btn 
						icon dark 
						class="text-decoration-none"
						:ripple="{ center: true }"
					>
						<tooltipInfo2 width="24" height="24" color="white"/>
					</v-btn>
				</div>
				<v-divider vertical inset class="d-none d-sm-flex" color="white"></v-divider>
				<div class="toolbar-item" @click="onLogout()">
					<div class="toolbar_comment_text d-none d-sm-flex">LOGOUT</div>
					<v-btn 
						icon dark
						class="text-decoration-none"
						:ripple="{ center: true }"
					>
						<exit width="24" height="24" color="white"/>
					</v-btn>
				</div>
			</v-toolbar-items>
		</v-toolbar>
		<div class="router_container" ref="router_container">
			<router-view
				:entries="route_entries"
				:color="route_color"
				:mini="mini"
				:reload="reload"
				:key="$route.fullPath"
				@stop_recording="onStopRecording()"
			/>
		</div>
		<AutoTimerDialog
			v-if="autotimer_visible"
			:visible="autotimer_visible"
			:taskTitle="task_title"
			:jobCode="job_code"
			:jobName="job_name"
			:taskId="recording_task_id"
			@close="onCloseAutotimer($event)"
			@stop-timer="onStopTimer($event)"
		/>
		<TaskTimesheet
			v-if="auto_time !== 0"
			:visible="auto_time !== 0"
			:taskId="recording_task_id"
			:autoDuration="auto_time"
			@close="onCloseTaskTimesheet()"
		/>
		<LogoutDialog 
			:visible="dialog_visible" 
			:type="`error`" 
			:title_text="`Log out?`" 
			:content_text="logout_text"
			:confirm_button="`LOG OUT`"
			:icon="logout_icon"
			@cancel="dialog_visible = false"
			@ok="goLogOut"
		/>
		<v-dialog
			v-if="task_detail_visible"
			v-model="task_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskDetail 
				:color="`#81CC00`"
				:task="task_detail_item"
				@find-ts="find_timesheet_id = $event"
				@task-copy="onDuplicateMenuItem($event)"
				@task-sub="onCreateSubTask($event)"
				@task-close="task_detail_visible = false; task_detail_item = null"
			/>
		</v-dialog>
		<ListTimesheetDialog
			v-if="find_timesheet_id !== 0"
			:visible="find_timesheet_id !== 0"
			:maxWidth="$vuetify.breakpoint.width * 0.85"
			:taskId="find_timesheet_id"
			@close="find_timesheet_id = 0"
			@openTs="timesheet_detail_item = $event; timesheet_detail_visible = true"
		/>
		<v-dialog
			v-if="timesheet_detail_visible"
			v-model="timesheet_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditTimesheet
				:editItem="timesheet_detail_item"
				:isAddTimesheet="false"
				:isLogTimesheet="true"
				@cancel-timesheet="timesheet_detail_item = null; timesheet_detail_visible = false"
			/>
		</v-dialog>
		<v-dialog
			v-if="task_create_visible"
			v-model="task_create_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskCreation 
				:color="'#81CC00'"
				:taskDetail="task_detail_item"
				:isSubTaskCreation="isSubTaskCreation"
				:isDuplication="isDuplication"
				@close="onTaskClose()"
			/>
		</v-dialog>
	</div>
</template>

<script>
import expenses from "@/components/icons/expenses";
import leave from "@/components/icons/leave";
import suitcase from "@/components/icons/suitcase";
import JobBagIcon from "@/components/icons/jobbag-icon";
import addressbook from "@/components/icons/addressbook";
import menuNew from "@/components/icons/menu_new";
import tooltipInfo2 from "@/components/icons/tooltip_Info2";
import chart from "@/components/icons/chart";
import help from "@/components/icons/help";
import info from "@/components/icons/info";
import exit from "@/components/icons/exit";
import setting from "@/components/icons/setting";
import autotimer from "@/components/icons/autotimer";
import ListTimesheetDialog from "@/views/timesheets/list_timesheet_dialog.vue";
import EditTimesheet from "@/views/timesheets/new_timesheet.vue";
import TaskCreation from "@/views/tasks/new_task.vue";

import breadcrumbs from "@/components/main/breadcrumbs";

// import group from "@/components/main/group";
import menuline from "@/components/main/menuline";
// import menuspacer from "@/components/main/menuspacer";

// profile
// import profile_menuline from "@/components/user/menuline";

// addressbook worklist
import abook_menuline from "@/components/addressbook/menuline";

// job worklist
import job_menuline from "@/components/jobs/menuline";

// tasks worklist
import tasks_menuline from "@/components/tasks/menuline";

// dialogues
import TaskTimesheet from "@/components/tasks/task_timesheet";
import AutoTimerDialog from "@/components/tasks/autotimer_dialog";
import LogoutDialog from "@/components/dialogs/confirm_dialog";
import TaskDetail from "@/views/tasks/edit_task.vue";

import config from "@/config.js";


const logout_text = 'You are about to be logged out of JobBag. Are you sure? ';
const LOGOUT_ICON = {
	name: exit,
	color: "white",
	width: 24, 
	height: 24,
};
const MENULINES = [
	{
		title: "Dashboard",
		color: "#CA66D2",
		to: "/",
		icon: JobBagIcon,
		divider: false,
		privilege: "",
		details: [],
	},
	{
		title: "Jobs",
		color: "#CA66D2",
		to: "/jobs",
		icon: suitcase,
		divider: false,
		active: false,
		privilege: "J",
		details: [
			// {
			// 	type: menuline,
			// 	title: "Create New Job",
			// 	to: "/jobs/create_new_job",
			// 	icon: suitcase,
			// 	enabled: true,
			// 	privilege: "",
			// },
			{
				type: menuline,
				title: "Search Jobs",
				to: "/jobs/search",
				icon: suitcase,
				enabled: true,
				privilege: "",
			},
			{
				type: job_menuline,
				title: "Saved Worklists",
				to: "/jobs/worklists",
				icon: suitcase,
				enabled: true,
				privilege: "",
			}
		],
	},
	{
		title: "Address Book",
		color: "#605AF6",
		to: "/addressbook",
		icon: addressbook,
		divider: false,
		privilege: "AB",
		details: [
			{
				type: abook_menuline,
				title: "Saved Worklists",
				to: "/addressbook/worklists",
				icon: addressbook,
				enabled: true,
				privilege: "",
			},
			{
				type: menuline,
				title: "Search Address Book",
				to: "/addressbook/search",
				icon: addressbook,
				enabled: true,
				privilege: "",
			},
		],
	},
	{
		title: "Tasks and Timesheets",
		color: "#81CC00",
		to: "/tasks",
		icon: chart,
		divider: false,
		privilege: "",
		details: [
			{
				type: tasks_menuline,
				title: "Tasklist",
				icon: chart,
				to: "/tasks/tasklist/0",
				enabled: true,
				privilege: "",
			},
			{
				type: menuline,
				title: "Calendar",
				icon: chart,
				to: "/tasks/timesheets",
				enabled: true,
				privilege: "",
			},
		],
	},
	{
		title: "Expenses",
		color: "#FFB946",
		to: "/expenses",
		icon: expenses,
		divider: false,
		enabled: true,
		privilege: "Sev",
		details: [],
	},
	{
		title: "Leave",
		color: "#FFB946",
		to: "/leave",
		icon: leave,
		divider: false,
		enabled: true,
		privilege: "",
		details: [],
	},
	{
		title: "Settings",
		color: "#605AF6",
		to: "/settings",
		icon: setting,
		divider: true,
		enabled: true,
		privilege: "AdmC",
		details: [],
	},
	{
		title: "About JobBag",
		color: "#888888",
		to: "/about",
		icon: info,
		divider: false,
		enabled: true,
		privilege: "",
		details: [],
	},
]	;
const MENU_WINNAME = 'Menu';

export default {
	name: "MenuContainer",
	data() {
		this.maxWidth_xs = '100%';
		this.width = '800';
		return {
			drawer: null,
			mini: true,
			reload: false,
			autotimer_visible: false,
			dialog_visible: false,
			task_detail_visible: false,
			logout_text: logout_text,
			logout_icon: LOGOUT_ICON,
			menulines: MENULINES,
			task_title: '',
			job_code: null,
			job_name: '',
			auto_time: 0,
			task_detail_item: null,
			find_timesheet_id: 0,
			timesheet_detail_visible: false,
			timesheet_detail_item: null,
			isDuplication: false,
			isSubTaskCreation: false,
			task_create_visible: false,
		}
	},
	computed: {
		route_entries() {
			let root_route = this.$route.matched[0].path;

			for (let i = 0; i < this.menulines.length; i++) {
				if (this.menulines[i].to == root_route) {
					return this.menulines[i].details;
				}
			}

			return [];
		},
		route_color() {
			let root_route = this.$route.matched[0].path;

			for (let i = 0; i < this.menulines.length; i++) {
				if (this.menulines[i].to == root_route) {
					return this.menulines[i].color;
				}
			}

			return "black";
		},
		user_short() {
			let user = this.$store.state.user;
			if (user) {
				if (user.addressbook) {
					let name = user.addressbook.display_name;
					if (name.includes(',')) {
						const name_arr = name.split(',');
						if (name_arr[1].includes('(')) {
							const name_tmp = name_arr[1];
							const index = name_tmp.indexOf('(');
							const first_name = name_tmp.substring(0, index-1).trim();
							const last_name = name_arr[0].trim();
							name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
						} else {
							const first_name = name_arr[1].trim();
							const last_name = name_arr[0].trim();
							name = `${first_name} ${last_name}`;
						}
					}
					return name;
				} else {
					return user.name;
				}
			}
			return "";
		},
		user_image() {
			let user = this.$store.state.user;
			if (user) {
				if (user.addressbook) {
					return user.addressbook.image;
				}
			}
			return "";
		},
		recording_task_id() {
			let recording_task_id_tmp = 0;
			if (this.$store.state.recording && this.$store.state.recording.task_id !== 0) {
				recording_task_id_tmp = this.$store.state.recording.task_id;
				this.load_task(recording_task_id_tmp);
			}
			return recording_task_id_tmp;
		}
	},
	components: {
		expenses, leave, suitcase, JobBagIcon, addressbook, chart, help, 
		exit, autotimer, breadcrumbs, TaskTimesheet, info, menuNew, tooltipInfo2,
		LogoutDialog, AutoTimerDialog, TaskDetail, ListTimesheetDialog, EditTimesheet, TaskCreation
	},
	created() {
		/* document360-widget-iframe, or beacon-container */
		const widget_name_str = 'beacon-container';

		/* to keep widget non-showing */
		const child = document.getElementById(widget_name_str);	

		if (child) {
			if (widget_name_str === 'document360-widget-iframe') {
				child.style.display = 'block';
			} else {
				child.style.display = 'block';

				const sub_child = document.getElementsByClassName('BeaconFabButtonFrame');
				sub_child[0].style.borderRadius = '60px';
				sub_child[0].style.height = '60px';
				sub_child[0].style.width = '60px';
			}			
		}
	},
	methods: {
		load_task(task_id) {
			axios
				.get("/api/tasks/" + task_id + "?comments=true&worked_on=true", {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						this.task_title = data.title;
						this.job_code = data.job.code;
						this.job_name = data.job.name;
					} else {
						console.log(reason);
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		onMenulineDetailClick(detail) {
			const keys = MENULINES[3].details.map(detail => { return detail.title });

			if (keys.includes(detail.title)) {
				/** update the settings if menu selection changing */
				const to_router = detail.to;
				const win_setup_obj = { to: to_router };
				const win_setup = JSON.stringify(win_setup_obj);

				const usid = this.$store.state.user.id;
				const winname_tmp = MENU_WINNAME;
				const winname = config.win_name[`${winname_tmp}`];

				const url = `/api/user/${usid}/webwinsetup/${winname}`;

				const params_obj = {};
				params_obj['value'] = win_setup;

				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
						} else {
							console.log(reason)
						}
					})
					.catch((e) => {
						console.log(e.message)
					});	

			}
		},
		onMenulineClick(menuline) {
			if (this.mini) {
				this.mini = false;
			}
			
			if (menuline.title === MENULINES[3].title) {
				const usid = this.$store.state.user.id;
				const winname_tmp = MENU_WINNAME;
				const winname = config.win_name[`${winname_tmp}`];

				const url = `/api/user/${usid}/webwinsetup/${winname}`;

				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							const current_path = this.$route.path;
							const length = menuline.details.length;

							if (data.length === 0) {
								if (current_path !== menuline.details[length - 1].to) {
									this.$router.push(menuline.details[length - 1].to);
								}
							} else {
								const current_settings = data.filter(d => { return d.user_id === usid });
								const settings_winname = current_settings[0].window_name;
								const settings_windata_json = current_settings[0].windata_json;
								if (settings_winname === winname) {
									const windata = JSON.parse(settings_windata_json);
									const to = windata.to;
									const current_path = this.$route.path;

									if (to && to.length !== 0 && current_path !== to) {
										this.$router.push(to)
									}
								}
							}
							
						} else {
							console.log(reason);
						}
					})
					.catch((e) => {
						console.log(e.message);
					});
			} else {
				const current_path = this.$route.path;
				const length = menuline.details.length;

				if (length !== 0 && current_path !== menuline.details[length - 1].to) {
					this.$router.push(menuline.details[length - 1].to);
				}
			}
		},
		onMenuClick() {
			if (!this.$vuetify.breakpoint.xs) {
				this.mini = !this.mini;
			}
			if (this.$vuetify.breakpoint.xs) {
				this.mini = false;
				this.drawer = !this.drawer;
			}
		},
		onStopRecording() {
			this.autotimer_visible = true;
		},
		onStopTimer(total_time) {
			this.auto_time = total_time;
		},
		onCloseAutotimer(task_id) {
			if (task_id) {
				this.autotimer_visible = false;
				this.task_detail_visible = true;
				this.task_detail_item = {
					id: task_id
				};
			} else {
				this.autotimer_visible = false;
			}
		},
		onCloseTaskTimesheet() {
			this.auto_time = 0;
			
			if (this.$route.name === 'Timesheets') {
				this.reload = true;
			}

			setTimeout(() => {
				this.reload = false
			}, 500);
		},
		onHelp() {
			this.$store.commit("clear_breadcrumbs");
			this.$router.push("/help");
		},
		onLogout() {
			this.dialog_visible = true;
		},
		style_color(section, color) {
			let root_route = this.$route.matched[0].path;
			if (root_route == section) {
				return "background-color: " + color;
			} else {
				return "";
			}
		},
		onDuplicateMenuItem(task) {
			this.task_detail_item = task;
			this.isDuplication = true;
			this.task_create_visible = true;

			this.task_detail_visible = false;
		},
		onCreateSubTask(task) {
			this.task_detail_item = task;
			this.isSubTaskCreation = true;
			this.task_create_visible = true;

			this.task_detail_visible = false;
		},
		onTaskClose() {
			this.task_detail_item = null;
			this.isDuplication = false;
			this.isSubTaskCreation = false;
			this.task_create_visible = false;
		},
		/* these are used in the mobile platform, need to see if we can replace them with with proper router links */
		// goProfile() {
		// 	this.$store.commit("clear_breadcrumbs");

		// 	this.$router.push("/profile");
		// },
		goJobs() {
			this.$store.commit("clear_breadcrumbs");

			this.$router.push("/jobs");
		},
		goHome() {
			this.$store.commit("clear_breadcrumbs");

			this.$router.push("/");
		},
		goAddressbook() {
			this.$store.commit("clear_breadcrumbs");

			this.$router.push("/addressbook");
		},
		goTasks() {
			this.$store.commit("clear_breadcrumbs");

			this.$router.push("/tasks");
		},
		goAbout() {
			this.$store.commit("clear_breadcrumbs");

			this.$router.push("/about");
		},
		goHelp() {
			this.$store.commit("clear_breadcrumbs");
			
			window.open("https://www.google.com", "_blank");

			// this.$router.push("/help");
		},
		goLogOut() {
			// just go back to the logon window..
			this.$router.push("/logon");
		},
	},
}
</script>

<style  lang="scss" scoped>
#main_container {
	padding: 0px;
	min-height: 100%;
	background-color: rgba(25, 42, 62, 0.1);
}
.navi-hover {
	z-index: 14;
	&:hover {
		box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.25);
	}
}
.menu-0:hover {
	background: rgba(202, 102, 210, 0.12);
}
.menu-1:hover {
  background: rgba(202, 102, 210, 0.12);
}
.menu-2:hover {
	background: rgba(96, 90, 246, 0.12);
}
.menu-3:hover {
	background: rgba(129, 204, 0, 0.12);
}
.menu-4:hover {
	background: rgba(255, 185, 70, 0.12);
}
.menu-5:hover {
  background:rgba(255, 185, 70, 0.12);
}
.menu-6:hover {
	background:rgba(136, 136, 136, 0.12);
}

.header_navigation {
	height: 48px;
}
.menu_group_item {
	padding-left: 54px;
}

.toolbar_title_text {
padding-top: 2px;
}
.toolbar-item {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	:hover {
		cursor: pointer;
	}
}
.toolbar_comment_text {
	font-size: 12px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	line-height: 20px;
	color: #FFFFFF;
}
.time-text {
	font-size: 12px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	line-height: 20px;
	color: #81CC00;
}
.user-avatar-tmp {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	margin: 0 8px;
}

.router_container {
	padding: 0px;
	width: 100%;
	min-height: 100%;
}
.footer_bar {
	background-color: #FAFAFA;
}
.icon-container {
	margin-top: 10px;
	height: 20px;
}
.button-text {
	margin-top:10px;
	font-size: 10px;
	color: black;
}
.jbicon {
	position: relative;
	top: -5px;
	left: 5px;
	width: calc(100% - 10px);
	height: 75px;
	padding-top: 10px;
	text-align: center;
	background-color: white;
	border-radius: 10px;
	box-shadow: 1px 2px 3px #DADADA;	
}
.v-tooltip__content {
  opacity: 1 !important;
	color: #ffffff !important;
	background-color: #CA66D2 !important;
}
::v-deep {
	.v-divider {
		border-color: #FFFFFF;
		margin-left: 10px;
		margin-right: 20px;
	}
}
</style>

